import { ColumnDef } from "@tanstack/react-table";
import clsx from "clsx";
import { PriceUpdateEmailDataInputRow } from "@/client-admin";
import { DataTableColumnHeader } from "@/components/ClientsheetTable/data-table-column-header.tsx";

export const columns: ColumnDef<PriceUpdateEmailDataInputRow & { product?: string }>[] = [
  {
    accessorKey: "product",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Product" />,
    cell: ({ row }) => {
      const product = row.getValue("product") as string | undefined;
      if (!product) return "-";

      return product
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
  },
  {
    accessorKey: "contract_name",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Contract" />,
  },
  {
    accessorKey: "price",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Price" />,
    cell: ({ row }) => {
      const price = row.getValue("price") as string | null;
      return price || "-";
    },
  },
  {
    accessorKey: "price_change_percentage",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Change %" />,
    cell: ({ row }) => {
      const changePercentage = row.getValue("price_change_percentage") as string | null;
      const direction = row.getValue("direction") as string | null;
      return (
        <span className={clsx(direction === "up" && "text-green-500", direction === "down" && "text-red-500")}>
          {changePercentage || "-"}
        </span>
      );
    },
  },
  {
    accessorKey: "price_change_in_eur",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Change EUR" />,
    cell: ({ row }) => {
      const changeEur = row.getValue("price_change_in_eur") as string | null;
      const direction = row.getValue("direction") as string | null;
      return (
        <span className={clsx(direction === "up" && "text-green-500", direction === "down" && "text-red-500")}>
          {changeEur || "-"}
        </span>
      );
    },
  },
  {
    accessorKey: "direction",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Direction" />,
    cell: ({ row }) => {
      const direction = row.getValue("direction") as string | null;
      return (
        <span className={clsx(direction === "up" && "text-green-500", direction === "down" && "text-red-500")}>
          {direction}
        </span>
      );
    },
  },
];
